const cardsData = [
  {
    title: '剑尊归来',
    genre: '玄幻·热血',
    desc: '一代剑尊重生于少年时期，带着前世记忆改写命运，逆天改命的传奇故事。画风精美，打斗场面燃爆！',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20illustration%20with%20swordsman%20in%20traditional%20eastern%20robes%20wielding%20glowing%20sword%20against%20dramatic%20sky%2C%20dynamic%20action%20pose%2C%20vibrant%20coral%20red%20and%20gold%20color%20scheme%2C%20clean%20simple%20background%20with%20energy%20effects%2C%20anime%20art%20style%20with%20bold%20lines%20and%20dramatic%20lighting&width=800&height=560&seq=manga-card-01&orientation=landscape',
  },
  {
    title: '女神降临',
    genre: '恋爱·校园',
    desc: '化妆逆袭的女主角在校园中展开的浪漫爱情故事，韩漫人气TOP级别，甜蜜又治愈的日常。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20of%20beautiful%20young%20woman%20with%20soft%20makeup%20look%20in%20school%20uniform%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20pink%20and%20coral%20tones%2C%20gentle%20lighting%2C%20clean%20simple%20pastel%20background%2C%20shojo%20manga%20art%20style%20with%20delicate%20linework&width=800&height=560&seq=manga-card-02&orientation=landscape',
  },
  {
    title: '我独自升级',
    genre: '热血·奇幻',
    desc: '从E级猎人到世界最强，系统流巅峰之作。酣畅淋漓的战斗升级，每一话都让人热血沸腾！',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20illustration%20of%20powerful%20hunter%20with%20glowing%20blue%20energy%20aura%20standing%20in%20dungeon%20ruins%2C%20intense%20action%20atmosphere%2C%20dramatic%20shadows%20and%20glowing%20effects%2C%20dark%20warm%20tone%20background%2C%20manhwa%20art%20style%20with%20sharp%20contrast%20and%20clean%20rendering&width=800&height=560&seq=manga-card-03&orientation=landscape',
  },
  {
    title: '狐妖小红娘',
    genre: '恋爱·玄幻',
    desc: '国漫之光！以狐妖为线索串联前世今生的爱情故事，笑中带泪，画风唯美，剧情深入人心。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20fantasy%20manga%20illustration%20of%20fox%20spirit%20girl%20with%20traditional%20hanfu%20dress%20under%20moonlight%2C%20flowing%20hair%20and%20ribbons%2C%20ethereal%20atmosphere%20with%20floating%20lanterns%2C%20warm%20golden%20and%20soft%20pink%20tones%2C%20elegant%20watercolor-like%20art%20style&width=800&height=560&seq=manga-card-04&orientation=landscape',
  },
  {
    title: '反派千金',
    genre: '恋爱·重生',
    desc: '穿越成小说里的恶役千金，为了活命开始逆天改命！剧情反套路，甜度爆表的异世界恋爱故事。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20illustration%20of%20noble%20lady%20in%20gorgeous%20gown%20holding%20fan%20in%20European-style%20palace%20interior%2C%20mischievous%20expression%2C%20sparkling%20atmosphere%2C%20warm%20golden%20and%20rose%20tones%2C%20clean%20romantic%20background%20with%20chandeliers%2C%20shojo%20manga%20art%20style&width=800&height=560&seq=manga-card-05&orientation=landscape',
  },
  {
    title: '全职高手',
    genre: '热血·竞技',
    desc: '荣耀之巅，王者归来！电竞题材巅峰国漫，叶修的传奇之路，从网吧重新开始的电竞神话。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20e-sports%20manga%20illustration%20of%20gamer%20character%20with%20headphones%20against%20cyberpunk%20background%2C%20keyboard%20and%20mouse%20in%20action%2C%20glowing%20screen%20reflections%2C%20energetic%20vibrant%20colors%20with%20coral%20and%20teal%20accents%2C%20modern%20anime%20art%20style%20with%20speed%20lines%20and%20particle%20effects&width=800&height=560&seq=manga-card-06&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑精选，为你推荐当下最值得一读的优秀漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-50 transition-all duration-300 no-underline"
            >
              <div className="relative aspect-[16/11] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 font-medium">
                    {card.genre}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}